module.exports = __webpack_public_path__ + "img/1503469981.56894ba5.jpg";